"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var DropPlaceholder = function DropPlaceholder(_ref) {
  var placeholder = _ref.placeholder;
  return /*#__PURE__*/React.createElement("div", {
    className: "pp-dropzone-dropplaceholder"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pp-dropzone-dropplaceholder-content"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pp-ico-download"
  }), /*#__PURE__*/React.createElement("span", null, placeholder)));
};

var _default = DropPlaceholder;
exports["default"] = _default;